<template>
  <ActionPlanWidget v-if="widgetData.type==='ActionPlanWidget'" :widget-data="widgetData" ref="childWidget"/>
  <ActivityGaugeWidget v-else-if="widgetData.type==='ActivityGaugeWidget'" :widget-data="widgetData" ref="childWidget"/>
  <AttentionWidget v-else-if="widgetData.type==='AttentionWidget'" :widget-data="widgetData" ref="childWidget"/>
  <ContainerWidget v-else-if="widgetData.type==='ContainerWidget'" :widget-data="widgetData" ref="childWidget"/>

  <DriversScatterChartWidget v-else-if="widgetData.type==='DriversDevChartWidget'" :widget-data="widgetData" ref="childWidget"/>
  <DriversScatterChartWidget v-else-if="widgetData.type==='DriversScatterChartWidget'" :widget-data="widgetData" ref="childWidget"/>
  <DriversTableWidget v-else-if="widgetData.type==='DriversTableWidget'" :widget-data="widgetData" ref="childWidget"/>

  <EffectsChartWidget v-else-if="widgetData.type==='EffectsChartWidget'" :widget-data="widgetData" ref="childWidget"/>

  <GaugeWidget v-else-if="widgetData.type==='GaugeWidget'" :widget-data="widgetData" ref="childWidget"/>
  <ColoredGoalWidget v-else-if="widgetData.type==='ColoredGoalWidget'" :widget-data="widgetData" ref="childWidget"/>
  <RankWidget v-else-if="widgetData.type==='RankWidget'" :widget-data="widgetData" ref="childWidget"/>

  <GenericChartWidget v-else-if="widgetData.type==='DevChartWidget' || widgetData.type==='PieChartWidget' || widgetData.type==='SegmentationsChartWidget' || widgetData.type==='GroupedChartWidget' || widgetData.type==='CategoryLinesChartWidget'" :widget-data="widgetData" ref="childWidget"/>
  <RankingTableWidget v-else-if="widgetData.type==='RankingTableWidget'" :widget-data="widgetData" ref="childWidget"/>

  <RowWidget v-else-if="widgetData.type==='RowWidget'" :widget-data="widgetData" ref="childWidget"/>
  <BlockWidget v-else-if="widgetData.type==='BlockWidget'" :widget-data="widgetData" ref="childWidget"/>

  <TabsWidget v-else-if="widgetData.type==='TabsWidget'" :widget-data="widgetData" ref="childWidget"/>

  <PoweredByGoogleWidget v-else-if="widgetData.type==='PoweredByGoogleWidget'" ref="childWidget"/>
  <ImageWidget v-else-if="widgetData.type==='ImageWidget'" :widget-data="widgetData"  ref="childWidget"/>
  <TextWidget v-else-if="widgetData.type==='TextWidget'" :widget-data="widgetData"  ref="childWidget"/>

  <div v-else>Unknown Widget: {{widgetData.type}}</div>
</template>

<script>
import AttentionWidget from "./AttentionWidget";
import GaugeWidget from "./GaugeWidget";
import RankingTableWidget from "./RankingTableWidget";
import RowWidget from "./RowWidget";
import RankWidget from "./RankWidget";
import ActionPlanWidget from "./ActionPlanWidget";
import ContainerWidget from "./ContainerWidget";
import ColoredGoalWidget from "./ColoredGoalWidget";
import BlockWidget from "./BlockWidget";
import TabsWidget from "./TabsWidget";
import GenericChartWidget from "./GenericChartWidget";
import DriversTableWidget from "./DriversTableWidget";
import EffectsChartWidget from "./EffectsChartWidget";
import DriversScatterChartWidget from "./DriversScatterChartWidget";
import ActivityGaugeWidget from "./ActivityGaugeWidget";
import PoweredByGoogleWidget from "@/views/dynpage/widgets/PoweredByGoogleWidget";
import ImageWidget from "@/views/dynpage/widgets/ImageWidget";
import TextWidget from "@/views/dynpage/widgets/TextWidget";

export default {
  name: 'Widget',
  components: {
    TextWidget,
    TabsWidget,
    ColoredGoalWidget,
    EffectsChartWidget,
    ActionPlanWidget, ActivityGaugeWidget, AttentionWidget, BlockWidget, ContainerWidget, DriversScatterChartWidget, DriversTableWidget, GaugeWidget, GenericChartWidget, ImageWidget, RankingTableWidget, PoweredByGoogleWidget, RankWidget, RowWidget},

  data() {
    return {
    }
  },

  props: {
    widgetData: Object,
    dataRequester: Object
  },


  methods: {
    requestData(requester) {
      this.$refs.childWidget.requestData(requester)
    },

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  wrapper {
    background-color: #aaaaaa;
}

</style>
